import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchWhatsAppActionCount } from '../lib/whatsappService';
import { useRealtimeInvalidation } from './useRealtimeInvalidation';

export { fetchWhatsAppActionCount };

export function useWhatsAppUnreadCount() {
  const { data: count = 0, refetch } = useQuery({
    queryKey: ['whatsapp', 'action-count'],
    queryFn: fetchWhatsAppActionCount,
    staleTime: 30_000,
  });

  const invalidate = useCallback(() => {
    refetch();
  }, [refetch]);

  useRealtimeInvalidation('whatsapp_conversations', invalidate);
  useRealtimeInvalidation('whatsapp_messages', invalidate);

  return { count };
}
